window._ = require('lodash');
window.axios = require('axios');
require('flatpickr');
import tippy from 'tippy.js';

import Swiper from 'swiper';
import { Navigation, Pagination, EffectCards, Manipulation } from 'swiper/modules';

tippy.setDefaultProps({animation: false});

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    window.csrfToken = token.content;
} else {
    console.error('CSRF token not found');
}

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Helpers
 */

require('element-closest');

window.ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
}

window.serialize = function (data) {
    let obj = {};
    for (let [key, value] of data) {
        if (obj[key] !== undefined) {
            if (!Array.isArray(obj[key])) {
                obj[key] = [obj[key]];
            }
            obj[key].push(value);
        } else {
            obj[key] = value;
        }
    }
    return obj;
}

window.isEmpty = function (data) {
    if (Array.isArray(data)) {
        return data.length == 0;
    }

    for (var prop in data) {
        if (Object.prototype.hasOwnProperty.call(data, prop)) {
            return false;
        }
    }

    return JSON.stringify(data) === JSON.stringify({});
}

window.selectHasOption = function (select, value) {
    var options = select.options;
    for (var i = 0; i < options.length; ++i) {
        if (options[i].value == value) {
            return true;
        }
    }
    return false;
}

if (!Array.prototype.last) {
    Array.prototype.last = function () {
        return this[this.length - 1];
    };
}

/**
 * General
 */

document.addEventListener('alpine:init', function() {

    Alpine.magic('tooltip', el => message => {
        let instance = tippy(el, { content: message, trigger: 'manual', allowHTML: true })

        instance.show()

        setTimeout(() => {
            instance.hide()

            setTimeout(() => instance.destroy(), 150)
        }, 2000)
    });

    Alpine.directive('tooltip', (el, { expression }, { cleanup }) => {
        var tooltip = tippy(el, { content: expression, allowHTML: true });
        cleanup(() => {
            if ( tooltip ) {
                tooltip.destroy();
            }
        })
    });

    Alpine.data('responsiveImage', () => ({
        size: null,
        load() {
            this.size = this.$el.getAttribute('sizes');
            window.requestAnimationFrame(function () {
                var size = this.$el.getBoundingClientRect().width;
                if (!size) {
                    return;
                }
                this.size = Math.ceil(size / window.innerWidth * 100) + 'vw';
                this.$el.setAttribute('sizes', this.size);
            }.bind(this));
        }
    }));

    Alpine.data('swiperCards', () => ({
        swiper: null,
        initialized: false,
        init() {
            this.swiper = new Swiper(this.$refs.swiper, {
                modules: [Navigation, Pagination, EffectCards, Manipulation],
                autoHeight: true,
                effect: 'cards',
                init: false,
                cardsEffect: {
                    slideShadows: false,
                },
                navigation: {
                    nextEl: this.$refs.buttonNext,
                    prevEl: this.$refs.buttonPrev,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
            });
            this.swiper.on('init', function() {
                this.initialized = true;
                this.$refs.slides.style.display = 'none';
                this.$refs.swiper.style.display = 'flex';
                this.drawSlides();
            }.bind(this));
            this.swiper.init();
        },
        drawSlides() {
            var slides = this.$refs.slides.querySelectorAll('.swiper-slide');
            var index = this.swiper ? this.swiper.activeIndex : 0;
            if ( slides.length > 0 ) {
                this.swiper.removeAllSlides();
                slides.forEach(function(slide) {
                     this.swiper.appendSlide(slide.cloneNode(true));
                }.bind(this));
                this.swiper.slideTo(index, 0);
            }
        },
        updateSlides() {
            if ( this.swiper ) {
                this.$nextTick(() => {
                    this.drawSlides();
                })
            }
        },
        destroy() {
            if ( this.swiper ) {
                this.swiper.destroy();
            }
        },
    }));

    Alpine.data('achievement', (achievement) => ({
        achievement,
        init() {
            var title = this.achievement.title;
            var body = this.achievement.description;
            tippy(this.$el, {
                render(instance) {
                    const popper = document.createElement('div');
                    const box = document.createElement('div');

                    popper.appendChild(box);

                    box.className = 'pointer-events-auto w-full max-w-[190px] overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5';
                    box.innerHTML = '<div class="p-4 text-center">' +
                    '<p class="text-sm font-medium text-gray-900">'+title+'</p>' +
                    '<p class="mt-1 text-sm text-gray-500">'+body+'</p>' +
                    '</div>';

                    return {popper};
                }
            });
        },
    }));
    Alpine.store('chat', {
        open: false,
        channel: null,
        ws: false,
        reporting: false,
        unread: false,
        init() {
            document.addEventListener('chat-active', (e) => {
                if ( e.detail.channel ) {
                    this.channel = e.detail.channel;
                }
                this.listen();
            });
            document.addEventListener('chat-leave', (e) => {
                if ( e.detail.channel ) {
                    this.channel = e.detail.channel;
                }
                this.stopListening();
            });
        },
        listen() {
            if ( this.ws ) {
                return;
            }
            if ( ! this.channel ) {
                return;
            }
            if ( typeof window.Echo == 'undefined' ) {
                return;
            }
            window.Echo.private(this.channel)
                .listen('ChatMessageCreated', function(payload) {
                    window.dispatchEvent(new CustomEvent('chat-message-created', {detail: {message: payload}}));
                    if ( ! this.open ) {
                        this.unread = true;
                    }
                }.bind(this))
                .listen('ChatMessageDeleted', function(payload) {
                    window.dispatchEvent(new CustomEvent('chat-message-deleted', {detail: {message: payload}}));
                }.bind(this))
                .listen('ChatMessageRestored', function(payload) {
                    window.dispatchEvent(new CustomEvent('chat-message-restored', {detail: {message: payload}}));
                }.bind(this));
            this.ws = true;
        },
        stopListening() {
            if ( ! this.ws ) {
                return;
            }
            if ( ! this.channel ) {
                return;
            }
            if ( typeof window.Echo == 'undefined' ) {
                return;
            }
            Echo.leave(this.channel);
            this.ws = false;
        },
        setUnread(unread) {
            this.unread = unread;
        },
        setReporting(reporting) {
            this.reporting = reporting;
        }
    });
    Alpine.store('mobileSidebar', {
        open: false,
    });
    Alpine.store('notificationsDialog', {
        open: false,
    });
    Alpine.data('map', (steps, distance, config = []) => ({
        steps,
        distance,
        config,
        map: null,
        init() {
            this.initMap();
        },
        ready() {
            return typeof google === 'object' && typeof google.maps === 'object' && typeof google.maps.LatLng  === 'function';
        },
        initMap() {
            if ( ! this.map && this.ready() ) {
                this.create();
                this.draw();
            }
        },
        create() {
            this.map = new google.maps.Map(this.$el, {
                zoom: parseInt(this.config.zoom),
                center: new google.maps.LatLng(this.config.center.lat, this.config.center.lng),
                mapTypeId: 'terrain',
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true
            });
        },
        draw() {
            var totalDistance = 0;
            var symbols = {
                walked: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 8,
                    fillColor: '#4f60fd',
                    fillOpacity: 1,
                    strokeOpacity: 0
                },
                unwalked: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 8,
                    fillColor: '#a8a8a8',
                    fillOpacity: 1,
                    strokeOpacity: 0
                }
            };
            var markers = [];
            var points = {
                walked: [],
                unwalked: []
            };
            var line = {};

            this.steps.forEach(function(step, stepIndex) {
                if (this.distance >= totalDistance) {
                    points.walked.push(new google.maps.LatLng(step.lat, step.lng));
                } else {
                    points.unwalked.push(new google.maps.LatLng(step.lat, step.lng));
                }

                if (step.points.length == 0) {

                    if (stepIndex < (this.steps.length - 1)) {
                        var nextStep = this.steps[stepIndex + 1];
                        var distancePastStep = this.distance - totalDistance;
                        if ((distancePastStep > 0) && (distancePastStep < step.distance)) {
                            var completion = distancePastStep / step.distance
                            var intermediate = this.straightLinePoint(step.lat, step.lng, nextStep.lat, nextStep.lng, completion);
                            points.walked.push(new google.maps.LatLng(intermediate.lat, intermediate.lng));
                        }
                    }

                    totalDistance += parseFloat(step.distance);

                } else {

                    step.points.forEach(function(point, pointIndex) {
                        if (this.distance >= totalDistance) {
                            points.walked.push(new google.maps.LatLng(point.lat, point.lng));
                        } else {

                            var lastPoint = pointIndex > 0 ? step.points[pointIndex - 1] : null;
                            var distancePastLastPoint = this.distance - ( totalDistance - ( lastPoint ? lastPoint.distance : 0 ) );
                            if ( lastPoint && ( distancePastLastPoint < lastPoint.distance ) && ( points.unwalked.length == 0 ) ) {
                                var completion = distancePastLastPoint / lastPoint.distance;
                                var intermediate = this.straightLinePoint(lastPoint.lat, lastPoint.lng, point.lat, point.lng, completion);
                                points.walked.push(new google.maps.LatLng(intermediate.lat, intermediate.lng));
                            }

                            points.unwalked.push(new google.maps.LatLng(point.lat, point.lng));
                        }
                        totalDistance += parseFloat(point.distance);
                    }, this);

                }

                markers.push(new google.maps.Marker({
                    icon: (this.distance >= parseFloat(step.distance_so_far) ? symbols.walked : symbols.unwalked),
                    position: new google.maps.LatLng(step.lat, step.lng),
                    title: step.title,
                    map: this.map
                }));

            }, this);

            if (points.walked.length > 0 && points.unwalked.length > 0) {
                points.unwalked.unshift(points.walked[points.walked.length - 1]);
            }

            if (points.walked.length > 0) {
                line.walked = new google.maps.Polyline({
                    path: points.walked,
                    geodesic: true,
                    strokeColor: '#4f60fd',
                    strokeOpacity: 0.9,
                    strokeWeight: 5
                });

                line.walked.setMap(this.map);
            }

            if (points.unwalked.length > 0) {
                line.unwalked = new google.maps.Polyline({
                    path: points.unwalked,
                    geodesic: true,
                    strokeColor: '#a8a8a8',
                    strokeOpacity: 0.9,
                    strokeWeight: 5
                });

                line.unwalked.setMap(this.map);
            }

        },
        panTo(lat, lng) {
            if ( this.map ) {
                this.map.panTo(new google.maps.LatLng(lat, lng));
            }
        },
        straightLinePoint(lat1, long1, lat2, long2, percent) {

            // Convert to radians.
            lat1 = lat1 * Math.PI / 180;
            lat2 = lat2 * Math.PI / 180;
            long1 = long1 * Math.PI / 180;
            long2 = long2 * Math.PI / 180;

            // get angular distance between points
            var d_lat = Math.abs(lat2 - lat1);
            var d_lon = Math.abs(long2 - long1);

            var a = Math.sin(d_lat / 2) * Math.sin(d_lat / 2) + Math.cos(lat1) * Math.cos(lat2) * Math.sin(d_lon / 2) * Math.sin(d_lat / 2);

            var d = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

            var A = Math.sin((1 - percent) * d) / Math.sin(d);
            var B = Math.sin(percent * d) / Math.sin(d);

            var x = A * Math.cos(lat1) * Math.cos(long1) + B * Math.cos(lat2) * Math.cos(long2);
            var y = A * Math.cos(lat1) * Math.sin(long1) + B * Math.cos(lat2) * Math.sin(long2);
            var z = A * Math.sin(lat1) + B * Math.sin(lat2);

            var lat3 = Math.atan2(z, Math.sqrt(x * x + y * y));
            var long3 = Math.atan2(y, x);

            // Return result, normalising longitude to -180°...+180°
            var outputLat = lat3 * 180 / Math.PI;
            var outputLong = long3 * 180 / Math.PI;

            return {lat: outputLat, lng: outputLong};
        },
    }));
    Alpine.data('countdown', (expires) => ({
        expires,
        timer: {
            days : 0,
            hours : 0,
            minutes : 0,
            seconds : 0,
        },
        init() {
            document.addEventListener('alpine:initialized', () => {
                if (this.expires && this.tick()) {
                    this.start();
                }
            });
        },
        destroy() {
            this.stop();
        },
        stop() {
            if ( this.interval ) {
                clearInterval(this.interval);
            }
        },
        start() {
            // this.$el.dispatchEvent(new CustomEvent('countdown-started'));
            this.interval = setInterval(() => {
                this.tick();
            }, 1000);
        },
        tick() {
            var difference = ( this.expires.getTime() - new Date().getTime() );
            if ( difference < 0 ) {
                return false;
            }
            this.timer.days = Math.floor(difference / (1000 * 60 * 60 * 24));
            this.timer.hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            this.timer.minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            this.timer.seconds = Math.floor((difference % (1000 * 60)) / 1000);
            return true;
        },
        finish() {
            // this.$el.dispatchEvent(new CustomEvent('countdown-finished'));
            this.stop();
        },
        format(number, suffix = '') {
            return number.toString().padStart(2, '0') + suffix;
        }
    }));
    Alpine.store('units', {
        items: [
            {
                'key': 'footsteps',
                'label': 'Steps',
            },
            {
                'key': 'kilometers',
                'label': 'Kilometers',
            },
            {
                'key': 'miles',
                'label': 'Miles',
            },
        ],
        all() {
            return this.items;
        },
        only(keys) {
            return this.items.filter(function(unit) {
                return keys.includes(unit.key);
            });
        },
        keys() {
            return this.items.keys();
        },
    });
    Alpine.store('conversions', {
        units: [],
        all: [],
        isMinutes() {
            return this.units.length == 1 && ( this.units[0] == 'minutes' );
        },
        find(code) {
            return this.all ? this.all.find(function(conversion) {
                return conversion[0] === code;
            }) || null: [];
        },
        filter(codes) {
            return this.all ? this.all.filter(function(conversion) {
                return codes.indexOf(conversion[0]) !== -1;
            }) : [];
        },
        replace(conversions) {
            this.all = conversions;
        },
    });
    Alpine.store('challenge', {
        data: {},
        init() {

        },
        destroy() {
            this.clearTimer();
        },
        update(data) {
            this.data.id = data.id;
            if ( data.starts ) {
                this.data.starts = data.starts;
            }
            if ( data.ends ) {
                this.data.ends = data.ends;
            }
            this.initTimer();
        },
        initTimer() {
            this.clearTimer();
            this.interval = setInterval(() => {
                this.tickTimer();
            }, 1000);
        },
        tickTimer() {
            var startsIn = Math.floor((this.data.starts.getTime() - new Date().getTime()) / 1000);
            var endsIn = Math.floor((this.data.ends.getTime() - new Date().getTime()) / 1000);
            if ( startsIn < 0 && endsIn < 0 ) {
                this.clearTimer();
                return;
            }
            if ( startsIn === 0 ) {
                setTimeout(function() {
                    window.dispatchEvent(new CustomEvent('ChallengeStarted'));
                }, 1000);
                return;
            }
            if ( endsIn === 0 ) {
                setTimeout(function() {
                    window.dispatchEvent(new CustomEvent('ChallengeEnded'));
                }, 1000);
                return;
            }
        },
        clearTimer() {
            if ( this.interval ) {
                clearInterval(this.interval);
            }
        },
    });
});

document.addEventListener('help.open', function(e) {
    if ( typeof $crisp != 'undefined' ) {
        $crisp.push(["do", "chat:open"]);
    } else if ( typeof window.Intercom == 'function' ) {
        Intercom('show');
    } else {
        window.open(e.target.getAttribute('href'));
    }
});

document.addEventListener('logout', function(e) {
    if ( typeof $crisp != 'undefined' ) {
        $crisp.push(["do", "session:reset"]);
        window.CRISP_TOKEN_ID = null;
    } else if ( typeof window.Intercom == 'function' ) {
        Intercom('shutdown');
    }
});

document.querySelectorAll('[data-logout]').forEach(function (button) {
    button.addEventListener('click', function (e) {
        console.log('logout');
    });
})
